import { useNavigate } from 'react-router-dom'
import EditableListPage from '../components/EditableListPage'
import { Button } from '../../shared/components/Button'
import { FaPen } from 'react-icons/fa'
import TableView from '../../shared/components/TableView'
import { useTranslation } from 'react-i18next'

const NewsletterCampaign = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const renderTable = items => {
        const columns = [
            {
                key: 'subject',
                label: t('fields.newsletter.fields.subject'),
            },
            {
                key: 'body',
                label: t('fields.newsletter.fields.body'),
            },
            { key: 'scheduled_at', label: t('fields.newsletter.fields.scheduled_at') },
            { key: 'sent_at', label: t('fields.newsletter.fields.sent_at') },
            { key: 'created_at', label: t('fields.newsletter.fields.created_at') },
            { key: 'updated_at', label: t('fields.newsletter.fields.updated_at') },
        ]

        const handleRowClick = item => {
            navigate(`/admin/auth/email-campaigns/${item.id}`)
        }

        return (
            <TableView
                data={items}
                columns={columns}
                onRowClick={handleRowClick}
                searchKeys={['subject']}
                searchPlaceholder={t('search.subject')}
            />
        )
    }

    return (
        <EditableListPage
            title={t('navigation_admin.newsletter.main')}
            endpoint='admin/newsletter-campaigns'
            renderTable={renderTable}
            view='table'
            rowLink='/admin/auth/email-campaigns'
            buttons={
                <Button
                    size='medium'
                    onClick={() => navigate('/admin/auth/email-campaigns/create')}
                >
                    <FaPen /> {t('status.create')}
                </Button>
            }
        />
    )
}

export default NewsletterCampaign
